/**
 * Definition of all routes of the application.
 */

export const routes = {
  statistics: {
    url: 'statistics',
    absoluteUrl: '/statistics',
  },
  production: {
    url: 'production',
    absoluteUrl: '/production',
  },
  quality: {
    url: 'quality',
    absoluteUrl: '/quality',
  },
  operators: {
    url: 'operators',
    absoluteUrl: '/operators',
  },
  notifications: {
    url: 'notifications',
    absoluteUrl: '/notifications',
  },
  condition: {
    url: 'condition',
    absoluteUrl: '/condition',
  },
  unhandledError: {
    url: 'serverunhandlederror',
    absoluteUrl: '/serverunhandlederror',
  },
};
